import moduleEnv from '@/constants/env'

const env = moduleEnv || process.env

export const SUB_SKU_SUFFIX = '$SUB'
export const CAMPAIGN_SKU_SUFFIX = '_C'
export const BRIDAL_SKU_SUFFIX = '_BR'
export const SYSTEM_PROGRAM_SKU_SUFFIX = '_SY'

export const MEAL_PROGRAM_SELLING_PLAN_ID =
  env.PUBLIC_MEAL_PROGRAM_SELLING_PLAN_ID
    ? parseInt(env.PUBLIC_MEAL_PROGRAM_SELLING_PLAN_ID)
    : 411107437
export const CLEAN_BOUTIQUE_SELLING_PLAN_ID =
  env.PUBLIC_CLEAN_BOUTIQUE_SELLING_PLAN_ID
    ? parseInt(env.PUBLIC_CLEAN_BOUTIQUE_SELLING_PLAN_ID)
    : 411140205
